import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    dialog: {
      textAlign: 'left',
      direction: 'ltr',
      padding: theme.spacing(2),
      lineHeight: 2,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    cancelButton: {
      marginLeft: '5px',
    },
    pagination: {
      width: '100%',
    },
    imgClass: {
      width: '100%',
    },
    addButton: {
      [theme.breakpoints.up('md')]: {
        transform: 'translate(5px, 31px)',
      },
    },
    isLoading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0',
    },
    isError: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      margin: '16px 0',
    },
    titleCategory: {
      fontWeight: 'bold',
      fontSize: '13px',
    },
    subItem: {
      fontSize: '12px',
      display: 'flex',
    },
    iconStyle: {
      width: '20px!important',
      height: '20px!important',
      minWidth: '20px!important',
      minHeight: '20px!important',
      border: '1px solid #ccc',
      backgroundColor: '#e5e5e5',
      borderRadius: '50%',
      paddingRight: '0!important',
      position: 'relative',
      '& svg': {
        position: 'absolute',
      }
    },
    blockLoading: {
      height: '400px',
      minHeight: '400px',
      overflow: 'hidden',
      position: 'relative',
    },
    iconTop: {
      color: 'white',
      backgroundColor: '#2B3990',
    },
    fonticon8: {
      width: '0.7em',
      height: '0.7em',
      color: '#43a047',
      margin: '0 4px',
      marginTop: '4px',
    },
    headItem: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: '#fff',
      padding: '0 10px ',
      borderRadius: '10px',
      height: 61,
      lineHeight: 61,
      fontWeight: 'bold',
      alignItems: 'center',
      overflow: 'hidden',
      color: '#0C0E10',
      [theme.breakpoints.up('md')]: {
        padding: '0 20px ',
      },
      '&.headItemActive': {
        borderRadius: '10px 10px 0 0',

      },
      '& span': {
        lineHeight: '25px',
        paddingRight: '15px',
        [theme.breakpoints.up('md')]: {
          paddingRight: '0',
        },


      }

    },

    collpaseContent: {
      borderTop: 'none',
      borderRadius: '0 0 10px 10px',
      backgroundColor: '#fff',
      borderTop: '0',
      margin: '0 2px',
    },
    mr8: {
      marginRight: '8px',
    },
    mr4: {
      marginRight: '4px',
      padding: '8px',
      marginTop: '12px',
      minHeight: '100px',
      '& img': {
        width: 'auto',
        maxWidth: '100%',
        margin: '20px 0',
      },
      // '& .divClass': {

      // },
    },
    pd16: {
      padding: '16px !important',
    },
    globalCustom: {
      '&.ulClass': {
        padding: '0 16px !important',
      },
    },
    ulClassCustom: {
      padding: '0 16px',
    },
    liCustom: {
      margin: '4px 0',
    },

    divImgCustom: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '8px',
    },
    imgCustom: {
      objectFit: 'contain',
      width: 'auto',
      maxWidth: '100%',
      height: 'auto',
      margin: '4px 0',
      [theme.breakpoints.down('sm')]: {
        '&:active': {
          transform: 'scale(1.5)',
        },
      },
    },
    tableCustom: {
      border: '1px solid #ccc',
      width: '100%',
    },
    trCustom: {
      border: '1px solid #ccc',
    },
    thCustom: {
      padding: '6px',
      textAlign: 'center',
      border: '',
      border: '1px solid #ccc',
    },
    tdContentCustom: {
      padding: '6px',
      border: '1px solid #ccc',
    },
    divCustomClass: {
      textAlign: 'justify',
      '& .transferClass': {
        paddingLeft: '10px',

        '& h3': {
          fontWeight: '800',
          fontSize: '15px',
          marginBottom: '10px',
        },
        '& p': {
          marginBottom: '10px',
          borderBottom: '1px solid #ccc',
          paddingBottom: '10px',
          textAlign: 'justify',
          '&:last-child': {
            borderBottom: '0px',
          },
        },
      },
    },
    colllapseTop: {
      margin: '0 auto 15px',
      borderRadius: '10px',
      // boxShadow:'-1px 3px 1px -1px #1018280F',
      maxWidth: ' 98%',
      border: '1px solid #dfdfdf !important'
    },
  };
});
